import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ReturnsModule } from '../returns/returns.module';

import { InfoTooltipComponent } from './components/item-order/info-tooltip/info-tooltip.component';
import { ItemOrderDetailComponent } from './components/item-order/item-order-detail/item-order-detail.component';
import {
    OrderTrackingComponent,
} from './components/item-order/item-order-detail/order-tracking/order-tracking.component';
import { ItemOrderComponent } from './components/item-order/item-order.component';
import { ItemOrderService } from './components/item-order/item-order.service';
import { OrdersTypeLayoutComponent } from './layouts/orders-type-layout/orders-type-layout.component';
import { OrderCancelComponent } from './modals/order-cancel/order-cancel.component';
import {
    OrderCancelConfirmComponent,
} from './modals/order-cancel-confirm/order-cancel-confirm.component';
import { OrderEguiComponent } from './modals/order-egui/order-egui.component';
import { OrdersTypeRoutingModule } from './orders-type-routing.module';
import { OrderDetailEffects } from './sections/order-detail/infrastructure/state/order-detail.effects';
import { OrdersTypeEffects } from './store/orders-type.effects';
import { ordersTypeReducers } from './store/orders-type.reducers';

import { StaticResourceService } from '@core/services/static-resource.service';
import { PaymentQrComponent } from '@features/payment-qr/payment-qr.component';
import { MdFormsModules } from '@shared/forms/forms.module';
import { GiftTicketDownloadModule } from '@shared/gift-ticket-download/components/gift-ticket-download.module';
import { OrderModule } from '@shared/order/order.module';
import { FormattedNumberPipe } from '@shared/pipes/formatted-number/formatted-number.pipe';
import { PipesModule } from '@shared/pipes/pipes.module';
import { PricePipe } from '@shared/pipes/price.pipe';
import { PricesModule } from '@shared/prices/prices.module';
import { ProductCommonModule } from '@shared/product/product-common.module';
import { ShopcartModule } from '@shared/shopcart/shopcart.module';
import { UiSvgIconModule } from '@shared/ui/svg-icon/svg-icon.module';
import { AccordionItemComponent } from '@ui/accordion-item/accordion-item.component';
import { QrcodeComponent } from '@ui/qrcode/qrcode.component';

@NgModule({
    declarations: [
        InfoTooltipComponent,
        ItemOrderComponent,
        ItemOrderDetailComponent,
        OrderCancelComponent,
        OrderCancelConfirmComponent,
        OrderEguiComponent,
        OrdersTypeLayoutComponent,
        OrderTrackingComponent,
    ],
    providers: [
        ItemOrderService,
        PricePipe,
        StaticResourceService,
    ],
    imports: [
        AccordionItemComponent,
        CommonModule,
        FormattedNumberPipe,
        FormsModule,
        GiftTicketDownloadModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('orders-type', ordersTypeReducers),
        EffectsModule.forFeature([OrdersTypeEffects, OrderDetailEffects]),
        InfiniteScrollModule,
        MdFormsModules,
        OrderModule,
        OrdersTypeRoutingModule,
        PaymentQrComponent,
        PipesModule,
        PricesModule,
        ProductCommonModule,
        QrcodeComponent,
        ReturnsModule,
        ShopcartModule,
        UiSvgIconModule,
    ],
    exports: [
        ItemOrderComponent,
    ],
})
export class OrdersTypeModule {}
